import { toast } from "react-toastify";
import { useState } from "react";
import api from "../../../../../api/axiosInstance";
const SyncUser = () => {
  const [inProcess, setInProcess] = useState(false);
  const syncUsers = () => {
    setInProcess(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API_URL + "Users/SyncCanvasUsers",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: {typeid: 4}
    };
    toast.info("Sync Users Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        toast.success("Sync Users Process Finished");
        CheckCanvasUsersStatus();
      } else {
        toast.error("Sync Users Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  const CheckCanvasUsersStatus = () => {
    setInProcess(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API_URL + "Users/CheckCanvasUsersStatus",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync Users Status Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        toast.success("Sync Users Status Process Finished");
      } else {
        toast.error("Sync Users Status Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  return (
    <>
      <button onClick={() => syncUsers()}>Sync User</button>
    </>
  );
};

export default SyncUser;
